import type { MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { PageResult } from '../../shared/data/types';
import type {
  CancelRuleInput,
  CommissionRuleCreateInput,
  CommissionRuleDetail,
  CommissionRuleListQuery,
  CommissionRulePreview,
  CommissionRulePreviewInput,
  CommissionRuleSummary,
  PublishRuleInput,
} from './types';

export interface CommissionRulesRepository {
  list(
    query: CommissionRuleListQuery,
    signal: AbortSignal,
  ): Promise<PageResult<CommissionRuleSummary>>;
  get(ruleId: string, signal: AbortSignal): Promise<CommissionRuleDetail>;
  preview(input: CommissionRulePreviewInput): Promise<CommissionRulePreview>;
  create(
    input: CommissionRuleCreateInput,
    idempotencyKey: string,
  ): Promise<MutationResult<CommissionRuleDetail>>;
  publish(
    ruleId: string,
    input: PublishRuleInput,
    idempotencyKey: string,
  ): Promise<MutationResult<CommissionRuleDetail>>;
  cancel(
    ruleId: string,
    input: CancelRuleInput,
    idempotencyKey: string,
  ): Promise<MutationResult<CommissionRuleDetail>>;
}

export const commissionRulesRepositoryToken =
  createRepositoryToken<CommissionRulesRepository>('commissionRules');

export const defaultCommissionRuleListQuery = Object.freeze<CommissionRuleListQuery>({
  page: 1,
  pageSize: 25,
  sort: 'createdAt',
  order: 'desc',
  filters: {
    scope: '',
    partnerId: '',
    gameTypeId: '',
    gameId: '',
    lifecycle: '',
    phase: '',
    effectiveFrom: '',
    effectiveTo: '',
  },
});
